import React from 'react';

export const Spinner: React.FC = () => (
  <div className="loading-page"><div className="spinner" /></div>
);
